export const format = (amount: string | number) => {
  const currencyFormatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  });

  function _format(amount: number) {
    return amount == 0 ? "Free" : currencyFormatter.format(amount);
  }

  if (typeof amount === "string") {
    const range = amount.split("-");
    if (range.length == 2) {
      return range[0] == "0" ? "Free" : `From ${_format(Number(range[0]))}`;
    }
  }

  return _format(Number(amount));
};
